import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b35c0b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexlayout-main-conent" }
const _hoisted_2 = {
  key: 0,
  class: "isShow"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "titleLeft" }
const _hoisted_5 = { class: "leftKey" }
const _hoisted_6 = { class: "leftChild" }
const _hoisted_7 = { class: "leftChild" }
const _hoisted_8 = {
  key: 0,
  class: "titleRight"
}
const _hoisted_9 = {
  key: 0,
  class: "hide"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "地点", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "描述", -1))
const _hoisted_12 = {
  key: 1,
  class: "show"
}
const _hoisted_13 = {
  key: 1,
  class: "titleRight"
}
const _hoisted_14 = { class: "hide" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "地点", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "描述", -1))
const _hoisted_17 = { class: "titleLeft childrenLeft" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leftKey" }, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "leftChild"
}
const _hoisted_20 = {
  key: 1,
  class: "leftChild"
}
const _hoisted_21 = {
  key: 2,
  class: "leftChild"
}
const _hoisted_22 = { class: "titleRight" }
const _hoisted_23 = { class: "show" }
const _hoisted_24 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_25 = {
  key: 1,
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_exclamation_circle_outlined = _resolveComponent("exclamation-circle-outlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, { style: {"width":"100%"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { gutter: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "物流单号",
                  labelCol: {span: 4},
                  wrapperCol: {span: 20}
                }, _ctx.validateInfos.gwosOrderNo), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      value: _ctx.modelRef.gwosOrderNo,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.gwosOrderNo) = $event)),
                      placeholder: "批量查询请使用空格或换行或英文逗号隔开,最多输入一百条数据"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.handleSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查询")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_a_button, { onClick: _ctx.handleRest }, {
                      default: _withCtx(() => [
                        _createTextVNode("重置")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.orderEvents.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleShowHide && _ctx.handleShowHide(...args)))
          }, "一键展开/收起")
        ]))
      : _createCommentVNode("", true),
    (_ctx.orderEvents.length > 0)
      ? (_openBlock(), _createBlock(_component_a_collapse, {
          key: 1,
          activeKey: _ctx.activeKey,
          "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeKey) = $event)),
          "expand-icon-position": "right",
          onChange: _ctx.handleGetKey
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderEvents, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                key: index+1
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(index+1), 1),
                      _createElementVNode("div", _hoisted_6, " 中国(CN) - " + _toDisplayString(item.destination), 1),
                      _createElementVNode("div", _hoisted_7, " 物流单号：" + _toDisplayString(item.gwtNo), 1)
                    ]),
                    (item.orderEvents)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_ctx.activeKey.some(item => item == index+1) && item.orderEvents)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_a_tooltip, null, {
                                    title: _withCtx(() => [
                                      _createTextVNode("已转化的北京时间")
                                    ]),
                                    default: _withCtx(() => [
                                      _createTextVNode(" 时间"),
                                      _createVNode(_component_exclamation_circle_outlined, { style: {"margin-left":"4px","color":"#30629C"} })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _hoisted_10,
                                _hoisted_11
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", null, _toDisplayString(item.orderEvents && item.orderEvents[0].eventTime), 1),
                                _createElementVNode("div", null, _toDisplayString(item.orderEvents && item.orderEvents[0].countryCode2), 1),
                                _createElementVNode("div", null, _toDisplayString(item.orderEvents && item.orderEvents[0].eventCodeCn), 1)
                              ]))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_a_tooltip, null, {
                                title: _withCtx(() => [
                                  _createTextVNode("已转化的北京时间")
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" 时间"),
                                  _createVNode(_component_exclamation_circle_outlined, { style: {"margin-left":"4px","color":"#30629C"} })
                                ]),
                                _: 1
                              })
                            ]),
                            _hoisted_15,
                            _hoisted_16
                          ])
                        ]))
                  ])
                ]),
                default: _withCtx(() => [
                  (item.orderEvents)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.orderEvents, (tag, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "contetnBox",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            (item.deliveredCycle != null && item.deliveredCycle > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createTextVNode("妥投天数(自然日): "),
                                  _createVNode(_component_a_tooltip, null, {
                                    title: _withCtx(() => [
                                      _createTextVNode("自小包收货确认开始计算，到包裹妥投结束")
                                    ]),
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.deliveredCycle) + "天", 1),
                                      _createVNode(_component_exclamation_circle_outlined, { style: {"margin-left":"4px","color":"#30629C"} })
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_20)),
                            (item.deliveryNo != null && item.deliveryNo != '')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 尾程派送单号:" + _toDisplayString(item.deliveryNo), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", null, _toDisplayString(tag.eventTime), 1),
                              _createElementVNode("div", null, _toDisplayString(tag.countryCode2), 1),
                              _createElementVNode("div", null, _toDisplayString(tag.eventCodeCn), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (item.gwtFlag)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, " 暂无物流数据 "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(item.remarks), 1))
                      ], 64))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["activeKey", "onChange"]))
      : _createCommentVNode("", true)
  ]))
}